import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { BuildingPermitRoutingModule } from './building-permit-routing.module';
import { BPNewRequestComponent } from './new-request/new-request.component';
import { BPNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [BPNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    BuildingPermitRoutingModule,
    MatSelectModule,
  ],
  providers: [BPNewRequestFormService],
})
export class BuildingPermitModule {}
